import PropTypes from "prop-types";
import { forwardRef, useImperativeHandle, useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import AssignVoicemailForm from "./AssignVoicemailForm";

const AssignVoicemailModal = forwardRef(({ onSuccess }, ref) => {
  const [open, setOpen] = useState(false);
  const [twilioPhoneNumberId, setTwilioPhoneNumberId] = useState();
  const [voicemailId, setVoicemailId] = useState();

  useImperativeHandle(ref, () => ({
    open: (nextTwilioPhoneNumberId, nextVoicemailId) => {
      setTwilioPhoneNumberId(nextTwilioPhoneNumberId);
      setVoicemailId(nextVoicemailId);
      setOpen(true);
    },
  }));

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle>Assign Voicemail</DialogTitle>
        {open && twilioPhoneNumberId != null && (
          <AssignVoicemailForm
            twilioPhoneNumberId={twilioPhoneNumberId}
            voicemailId={voicemailId}
            onSuccess={handleSuccess}
          />
        )}
      </DialogContent>
    </Dialog>
  );
});

AssignVoicemailModal.displayName = "AssignVoicemailModal";

AssignVoicemailModal.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default AssignVoicemailModal;
